function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#212121",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M2.828 0l21.92 21.92-2.828 2.828L0 2.828z"
}), React.createElement("path", {
  d: "M0 21.92L21.92 0l2.828 2.828-21.92 21.92z"
}));

function SvgCloseIcon(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 25
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij48ZyBmaWxsPSIjMjEyMTIxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjgyOCAwbDIxLjkyIDIxLjkyLTIuODI4IDIuODI4TDAgMi44Mjh6Ii8+PHBhdGggZD0iTTAgMjEuOTJMMjEuOTIgMGwyLjgyOCAyLjgyOC0yMS45MiAyMS45MnoiLz48L2c+PC9zdmc+";
export { SvgCloseIcon as ReactComponent };